import { ComponentStyleConfig } from "@chakra-ui/react";

// Shared field look for Input, Select, Textarea and NumberInput
export const fieldStyle = {
  bg: "white",
  borderWidth: "1px",
  borderColor: "line.DEFAULT",
  borderRadius: "md",
  color: "ink.DEFAULT",
  _placeholder: { color: "ink.subtle" },
  _hover: { borderColor: "brand.300" },
  _focusVisible: {
    borderColor: "brand.500",
    boxShadow: "0 0 0 3px rgba(79, 70, 229, 0.15)",
  },
  _invalid: {
    borderColor: "#ba1a1a",
    boxShadow: "0 0 0 1px #ba1a1a",
  },
  _readOnly: {
    bg: "surface.low",
    color: "ink.muted",
    cursor: "not-allowed",
  },
};

export const ReiInput: ComponentStyleConfig = {
  variants: {
    outline: {
      field: fieldStyle,
    },
  },
  defaultProps: {
    variant: "outline",
  },
};
